import React, { useState } from 'react';
import {
  Box, Button, Container, TextField, Typography, Alert
} from '@mui/material';
import axios from 'axios';
import BASE_API_URL from '../apis/index';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (!email) {
      setMessage({ type: 'error', text: 'Email is required' });
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${BASE_API_URL}/api/auth/forgot-password`, { email });
      setMessage({ type: 'success', text: res.data.message });
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Something went wrong';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, p: 4, boxShadow: 2, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Forgot Password
        </Typography>

        {message.text && (
          <Alert severity={message.type} sx={{ mb: 2 }}>
            {message.text}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            className='w-100'
            label="Enter your email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
          />
          <Button
            type="submit"
            className='w-100'
            variant="contained"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
